import React from "react";
import { Button } from "./ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { formatMonat } from "../lib/utils";

function shiftMonth(value, delta) {
  if (!value) return value;
  const [y, m] = value.split("-").map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function MonthPicker({ value, onChange, testId = "month-picker" }) {
  return (
    <div className="flex items-center gap-1">
      <Button
        variant="outline"
        size="icon"
        className="h-9 w-9 border-neutral-300"
        onClick={() => onChange(shiftMonth(value, -1))}
        aria-label="Vorheriger Monat"
        data-testid={`${testId}-prev`}
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <div className="relative w-28 sm:w-32">
        <div
          className="flex h-9 w-full items-center justify-center rounded-md border border-neutral-300 bg-white font-mono text-sm pointer-events-none"
          data-testid={`${testId}-display`}
        >
          {formatMonat(value)}
        </div>
        <input
          data-testid={testId}
          type="month"
          value={value}
          onChange={(e) => e.target.value && onChange(e.target.value)}
          className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
          aria-label="Monat wählen"
        />
      </div>
      <Button
        variant="outline"
        size="icon"
        className="h-9 w-9 border-neutral-300"
        onClick={() => onChange(shiftMonth(value, 1))}
        aria-label="Nächster Monat"
        data-testid={`${testId}-next`}
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
}

export function PageHeader({ title, subtitle, children, testId }) {
  return (
    <div
      className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6"
      data-testid={testId}
    >
      <div>
        <h1 className="text-xl sm:text-2xl lg:text-3xl font-semibold tracking-tight">{title}</h1>
        {subtitle && <p className="mt-1 text-xs sm:text-sm text-neutral-500">{subtitle}</p>}
      </div>
      {children && <div className="flex gap-2 flex-wrap">{children}</div>}
    </div>
  );
}

export function PageContainer({ children }) {
  return <div className="p-4 sm:p-6 lg:p-8 max-w-[1600px] mx-auto">{children}</div>;
}
